(function(){
    var setIndexes = function (key, totalOfInputs) {
        var counter = 0;
        var index = 0;
        var elements = document.getElementsByClassName(key);
        for (var idx = 0; idx < elements.length; idx++) {
            if (elements[idx].nodeName !== 'DIV') {
                if (elements[idx].name) {
                    elements[idx].name = elements[idx].name.replace('index', counter);
                }
                if (elements[idx].id) {
                    elements[idx].id = elements[idx].id.replace('index', counter);
                }

                index++;

                if (index % totalOfInputs === 0) {
                    counter++;
                }
            }
        }
        return true;
    };

    function ucfirst( str )
    {
        var pieces = str.split(" ");
        for ( var i = 0; i < pieces.length; i++ )
        {
            var j = pieces[i].charAt(0).toUpperCase();
            pieces[i] = j + pieces[i].substr(1);
        }
        return pieces.join(" ");
    }

    var unsetIndexes = function (key) {
        var elements = document.getElementsByClassName(key);
        for (var idx = 0; idx < elements.length; idx++) {
            if (elements[idx].nodeName !== 'DIV') {
                if (elements[idx].name) {
                    elements[idx].name = elements[idx].name.replace(/[0-9]/g, 'index');
                }
            }
        }
        return true;
    };

    var generateUid = function() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    };

    var contains = function (text, key) {
        if(text !== undefined && key !== undefined) {
            return text.toLowerCase().indexOf(key.toLowerCase()) !== -1;
        }

        return false;
    };

    var roundup = function(n) {
        return parseFloat(parseFloat(Math.round(n * 100) / 100).toFixed(2));
    };

    var unmaskArea = function (val) {
        var value = (val || "0"),
            isNegative = value.indexOf("-") !== -1,
            decimalPart;

        // get the last position of the array that is a number(coercion makes "" to be evaluated as false)
        $(value.split(/\D/).reverse()).each(function (index, element) {
            if (element) {
                decimalPart = element;
                return false;
            }
        });
        value = value.replace(/\D/g, "");
        value = value.replace(new RegExp(decimalPart + "sq.ft."), "." + decimalPart);
        if (isNegative) {
            value = "-" + value;
        }
        return parseFloat(value);
    };

    var truncate = function(text, max, title, tag)
    {
        if(text) {
            var a = $("<a/>");
            a.html('Read More');
            a.addClass('modal-trigger');
            a.attr('href', '#read-more');
            a.attr('data-title', title);
            if (tag) {
                a.attr('data-content', '<' + tag + '>' + text + '</' + tag + '>');
            } else {
                a.attr('data-content', text);
            }
            a.attr('data-read-more', true);

            return text.toString().substr(0, max - 1) + (text.length > max ? '...' + '<br/>' + a[0].outerHTML : '');
        } else {
            return '';
        }
    };

    var getUSACenter = function() {
        return {
            lat: 37.09024,
            lng: -95.71289100000001
        };
    };

    var getPropertyCenter = function() {

    };

    var hideImage = function(obj) {
        $(obj).addClass('hide');
    };

    var replaceImage = function(obj, type) {
        if(type === 'add') {
            $(obj).attr('src',  $('body').attr('data-base-url') + "assets/img/add-placeholder.png");
            $(obj).css('object-fit', 'contain');
        } else {
            $(obj).attr('src',  $('body').attr('data-base-url') + "assets/img/default-placeholder.png");
        }
    };

    var imageUrl = function(url) {
       if(contains(url, 'upload/') || contains(url, 'assets/')) {
           return $('body').attr('data-base-url') + url;
       } else {
           return $('body').attr('data-cdn-url') + url;
       }
    };

    var getToday = function() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        return mm + '/' + dd + '/' + yyyy;
    };

    if (window.Utils === undefined) {
        window.Utils = {};
    }


    window.Utils = {
        setIndexes: setIndexes,
        unsetIndexes: unsetIndexes,
        generateUid: generateUid,
        contains: contains,
        roundup: roundup,
        unmaskArea: unmaskArea,
        ucfirst: ucfirst,
        truncate: truncate,
        getUSACenter: getUSACenter,
        getPropertyCenter: getPropertyCenter,
        hideImage: hideImage,
        replaceImage: replaceImage,
        imageUrl: imageUrl,
        getToday: getToday
    };
})();